import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { Network } from 'data/network/network.types';

// eslint-disable-next-line import/prefer-default-export
export function createNetworkBasedOnTemplate(
  template: FormTemplate,
): Network {
  const network: Partial<Network> = {
    ...getFieldValuesFromSection(template.main as FormTemplateSection),
  };

  return omitBy(network, isNil) as unknown as Network;
}

function getFieldValuesFromSection(
  templateSection: FormTemplateSection,
): Partial<Network> {
  return Object.entries(templateSection?.fields)
    .filter(([_fieldName, field]) => field.initial != null)
    .reduce((previousValue, [fieldName, field]) => ({
      ...previousValue,
      [fieldName]: field.initial,
    }), {});
}
